import { IoCheckmark } from "react-icons/io5";

export type Step = {
  id: number;
  label: string;
  icon: React.ReactNode;
  completed?: boolean;
};

interface ReportStepperProps {
  steps: Step[];
  currentStep: number;
}

export const ReportStepper = ({ steps, currentStep }: ReportStepperProps) => {
  return (
    <div className="fixed top-16 md:top-20 lg:top-[72px] left-0 right-0 bg-white shadow-md z-40 py-3 md:py-4">
      <div className="flex items-center justify-center px-4">
        <div className="flex items-center max-w-full overflow-x-auto scrollbar-hide">
          {steps.map((step, index) => {
            const isActive = currentStep === step.id;
            const isCompleted = currentStep > step.id;
            const isLast = index === steps.length - 1;

            return (
              <div key={step.id} className="flex items-center">
                <div className="flex flex-col items-center">
                  <div
                    className={`w-11 h-11 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg md:rounded-xl flex items-center justify-center transition-all duration-300 ${
                      isCompleted
                        ? "bg-[hsl(var(--primary))]/20"
                        : isActive
                          ? "bg-[hsl(var(--primary))]/20"
                          : "bg-gray-300/30"
                    }`}
                  >
                    {isCompleted ? (
                      <IoCheckmark className="text-[hsl(var(--primary))] text-xl md:text-xl lg:text-2xl" />
                    ) : (
                      <div
                        className={`text-xl md:text-xl lg:text-2xl ${
                          isActive
                            ? "text-[hsl(var(--primary))]"
                            : "text-gray-400"
                        }`}
                      >
                        {step.icon}
                      </div>
                    )}
                  </div>
                  <span
                    className={`text-[10px] md:text-xs mt-1.5 md:mt-2 font-medium whitespace-nowrap ${
                      isActive || isCompleted
                        ? "text-[hsl(var(--primary))]"
                        : "text-gray-400"
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {!isLast && (
                  <div className="w-8 md:w-10 lg:w-12 h-1 mx-2 md:mx-3 -mt-5 md:-mt-6">
                    <div
                      className={`h-full rounded transition-all duration-300 ${
                        isCompleted ? "bg-[hsl(var(--primary))]" : "bg-gray-300"
                      }`}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
